
import bloodSeries from '../assets/images/Mintnft/bloodSeries.png'
import undNFTLogo from '../assets/images/Mintnft/undNFTLogo.png'

export interface mintNFTDataType {
    id: number,
    nftImage: string,
    nftTitle: string,
    price: number,
    supply: number,
    minted: number,
    yourBalance: number,
    maxMint: number,
}

export const mintNFTData: mintNFTDataType[] = [
    {
        id: 1,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 2,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 3,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 4,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 5,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 6,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 7,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 8,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 9,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 10,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 11,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 12,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 13,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 14,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 15,
        nftImage: bloodSeries,
        nftTitle: 'First Blood Series',
        price: 0.23,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
    {
        id: 16,
        nftImage: undNFTLogo,
        nftTitle: 'UND logo',
        price: 0.20,
        supply: 18,
        minted: 15,
        yourBalance: 0,
        maxMint: 5,
    },
]





export interface stakeNftDataType {
    id: number,
    nftImage: string,
    apr: number,
    depositFee: number,
    earn: string,
    usdtEarn: number,
    stake: string,
    details: {
        totalStaked: number,
        maxStakePerUser: number,
        depositFeePerItem: number,
        withdrawFeePerItem: number,
        endsIn: number,
    },
}


export const stakeNftData: stakeNftDataType[] = [
    {
        id: 1,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 2,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 3,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 4,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 5,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 6,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 7,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 8,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 9,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 10,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },
    {
        id: 11,
        nftImage: undNFTLogo,
        apr: 14.247,
        depositFee: 5,
        earn: 'UNC',
        usdtEarn: 12,
        stake: 'UND',
        details: {
            totalStaked: 1,
            maxStakePerUser: 1,
            depositFeePerItem: 0.025,
            withdrawFeePerItem: 0.025,
            endsIn: 8157018,
        },
    },]






export interface stakedNFTsDataType {
    id: number,
    tokenID: string,
    nftPhoto: string,
}

export const stakedNFTs: stakedNFTsDataType[] = [
    {
        id: 1,
        tokenID: '445',
        nftPhoto: bloodSeries,
    },
    {
        id: 2,
        tokenID: '446',
        nftPhoto: bloodSeries,
    },
    {
        id: 3,
        tokenID: '447',
        nftPhoto: bloodSeries,
    },
    {
        id: 4,
        tokenID: '448',
        nftPhoto: bloodSeries,
    },
    {
        id: 5,
        tokenID: '449',
        nftPhoto: bloodSeries,
    },
    {
        id: 6,
        tokenID: '450',
        nftPhoto: bloodSeries,
    },
    {
        id: 7,
        tokenID: '451',
        nftPhoto: bloodSeries,
    },
    {
        id: 8,
        tokenID: '451',
        nftPhoto: bloodSeries,
    },
]